import React from "react"

import config from "config"

import { useSearchContainer } from "hooks/search/useSearchContainer"
import { SearchPopupContent } from "components/domains/search"
import { useMediaQuery, useTheme } from "@mui/material"

export const SearchContainer = ({
  showOnscreenKeyboard: showOnscreenKeyboardProp = undefined,
  renderComponent: RenderComponent = SearchPopupContent,
}) => {
  const {
    openSearchState,
    searchInputRef,
    keyboardRef,
    endScrollRef,
    searchResultItems,
    searchValue,
    showOnscreenKeyboard,
    venueFilter,
    sortedParentCategoryWithOccupant,
    suggestedListItems,
    hasNextPage,
    keyboardLangs,
    onClose,
    onChange,
    onChangeKeyboard,
    onClickCategory,
    onSelectResult,
    onClickClearSearchValue,
    setVenueFilter,
    onClickSuggestedItem,
  } = useSearchContainer({ showOnscreenKeyboard: showOnscreenKeyboardProp })

  //TODO:: remove this condition when implement kiosk-v search container to kiosk-h version
  const device = config("device")
  const isKiosk = /^kiosk/.test(device)
  const theme = useTheme()
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"))
  const popupType = isKiosk || matchUpMd ? "Dialog" : "Drawer"

  return (
    <React.Fragment>
      <RenderComponent
        keyboardRef={keyboardRef}
        openSearchState={openSearchState}
        searchInputRef={searchInputRef}
        searchResultItems={searchResultItems}
        searchValue={searchValue}
        searchResultProps={{ endScrollRef, hasNextPage }}
        showOnscreenKeyboard={showOnscreenKeyboard}
        onClose={onClose}
        onChange={onChange}
        onChangeKeyboard={onChangeKeyboard}
        onSelectResult={onSelectResult}
        popupType={popupType}
        onClickClearSearchValue={onClickClearSearchValue}
        venueFilter={venueFilter}
        setVenueFilter={setVenueFilter}
        categories={sortedParentCategoryWithOccupant}
        onClickCategory={onClickCategory}
        suggestedListItems={suggestedListItems}
        onClickSuggestedItem={onClickSuggestedItem}
        searchKeyboardProps={{ languages: keyboardLangs }}
      />
    </React.Fragment>
  )
}
